import { styled, useTheme } from '@mui/material/styles'
import TableCell from '@mui/material/TableCell'

export const useStyleProduct = (_props?: any) => {
  const theme = useTheme()
  return {
    root: 'p-3 mb-3 mr-0.5 max-h-[336px] text-center flex flex-col cursor-pointer tracking-wide rounded-[15px]',
    rootListMode: 'p-2 w-full cursor-pointer',
    topBar: 'flex h-3 mb-2',
    productName: 'font-semibold text-left leading-none',
    ean: 'italic text-left text-xs min-h-[10px]',
    marque: `font-bold text-left min-h-[18px] mr-2.5`,
    marqueStyle: { color: theme.palette.secondary.main },
    productInfo: 'flex flex-row justify-between items-center',
    priceLine: 'flex justify-between items-center text-xs',
    flexContainerPrice: 'flex flex-col justify-center',
    price: 'font-extrabold text-lg',
    priceStyle: { color: theme.palette.primary.main },
    priceLineOld: 'flex justify-end items-center',
    priceOld: 'font-extrabold text-[10px] line-through',
    priceOldList: 'line-through',
    percent: 'font-extrabold text-xs mr-1 whitespace-nowrap',
    percentStyle: { color: theme.palette.secondary.main },
    spacePriceOld: 'mt-2.5',
  }
}

export const StyledTableCell = styled(TableCell)({
  '&.MuiTableCell-head': { fontWeight: 700 },
  '&.MuiTableCell-sizeSmall': { padding: '8px' },
})
